// extracted by mini-css-extract-plugin
export default {"adContainer":"Adsense_adContainer__QHk+V","adBlock":"Adsense_adBlock__Rrbld"};